import { FormGroup } from '@mui/material';
import { useState } from 'react';
import { SeverityCheckbox } from '../../../../common/components/SeverityCheckbox';
import { Severity } from '../../../../common/enums/Severity';

export type SeverityFilter = {
  severity: Severity;
  count: number;
};

type Props = {
  severities: SeverityFilter[];
  onChange: (severities: Severity[]) => void;
};

export const SeverityFilter = ({ severities, onChange }: Props) => {
  const [formValue, setFormValue] = useState(severities.filter((s) => s.count).map((s) => s.severity));

  const onCheckboxChange = (severity: Severity, checked: boolean) => {
    let newValue: Severity[] = [];
    if (checked && !formValue.includes(severity)) {
      newValue = [...formValue, severity];
    }
    if (!checked) {
      newValue = formValue.filter((s) => s !== severity);
    }
    setFormValue(newValue);
    onChange(newValue);
  };

  return (
    <FormGroup className="severity-filter" sx={{ display: 'flex', flexDirection: 'row', pl: 3.375, borderTop: '1px solid', borderColor: 'grey.200' }}>
      {severities.map((s) => {
        const checked = formValue.includes(s.severity);
        const disabled = s.count === 0;
        const ariaLabel = checked ? 'a11y.report.issues.severityToggleChecked' : 'a11y.report.issues.severityToggleUnchecked';
        return (
          <SeverityCheckbox
            key={s.severity}
            severity={s.severity}
            ariaLabelBase={ariaLabel}
            checked={checked}
            disabled={disabled}
            onChange={(checked) => onCheckboxChange(s.severity, checked)}
          />
        );
      })}
    </FormGroup>
  );
};
